import React,{ useState, useEffect, useRef } from 'react';
import { useNavigate  } from 'react-router-dom';
import { Input, Row, Col, Divider } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import Menu from '../../../components/Menu/Menu'
import CardDom from '../../../components/CardDom/CardDom'

// getBlogInfo
import { getBlogList } from '../../../api/article'

import './Blog.less'

const Blog = () =>{
  const navigate = useNavigate();
  
  const [selectMenu, setSelectMenu] = useState('')
  const menuData = [
    {label: '全部',value: '0'},
    // {label: 'News',value: '1'},
    // {label: 'Nutrition',value: '2'},
    // {label: 'Skincare',value: '3'},
    // {label: 'Studies',value: '4'},
    // {label: 'Podcasts',value: '5'}
  ]
  // 是否显示侧边目录
  const [isDirectory, setIsDirectory] = useState(true)

  
  let [articleList, setArticleList] = useState([])

  let [directoryList, setDirectoryList] = useState([])

  const [width, setWidth] = useState(window.innerWidth);
  useEffect(()=>{
    setTimeout(()=>{
      setSelectMenu(menuData[0])
    },100)

    const handleResize = () => {
      setWidth(window.innerWidth);
    };
 
    // 添加事件监听器
    window.addEventListener('resize', handleResize);

    // 清理函数，组件卸载时移除事件监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  },[])

  
  const getBlogListFn = async (title) =>{
    let update = {
      page: 1,
      limit: 100,
      status: 1
      // categoryType: 1
    }
    if(title) update.title = title
    let res = await getBlogList(update)
    console.log('BlogList', res?.data)
    if(res?.msg === 'success'){
      directoryList = []
      let data = res?.data.map((e,i)=>{
        // console.log(e)
        const now = new Date(e.updatedTime);
        const Y = now.getFullYear();
        const M = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
        const D = String(now.getDate()).padStart(2, '0');
        const h = String(now.getHours()).padStart(2, '0');
        const m = String(now.getMinutes()).padStart(2, '0');
        const s = String(now.getSeconds()).padStart(2, '0');


        if(i <= 2){
          directoryList.push({
            type: 'img2',
            content: {
              // img: <img src={e.coverImage} style={{width: '100%',borderRadius:5}}/>,
              img: <div style={{width: '100%',height:'20vh',background: `url(${e.coverImage}) no-repeat center center/cover`}}></div>,
              title: e.title,
              // taglist: ['News', 'Nutrition','Studies'],
              time: `${Y}-${M}-${D} ${h}:${m}:${s}`
            },
            btnConfig: {
              link: e.articleUrl? e.articleUrl:`/aBoutDetail?id=${e.id}`,
              linkType: e.articleUrl? '_blank':''
            }
          })
          setDirectoryList(()=> directoryList)
        }

        return {
          type: 'img2',
          content: {
            // img: <img src={e.coverImage} style={{width: '100%',borderRadius:5}}/>,
            img: <div style={{width: '100%',height:'20vh',background: `url(${e.coverImage}) no-repeat center center/cover`}}></div>,
            title: e.title,
            // taglist: ['News', 'Nutrition','Studies'],
            time: `${Y}-${M}-${D} ${h}:${m}:${s}`
          },
          btnConfig: {
            link: e.articleUrl? e.articleUrl:`/aBoutDetail?id=${e.id}`,
            linkType: e.articleUrl? '_blank':''
          }
        }
      })
      // console.log(res?.data)
      setArticleList(()=> data)
    }
  }

  useEffect(()=>{
    if(selectMenu.label){
      if(selectMenu.label === '全部' || selectMenu.label === 'Podcasts'){
        setIsDirectory(true)
      }else{
        setIsDirectory(false)
      }
      getBlogListFn()
    }
  }, [selectMenu])

  if(width > 770){
    return (
      <div className="Blog-page" style={{textAlign: 'left'}}>
        <div className="bigTitle">
          论文
        </div>
  
        
        <div style={{width: '100%', maxWidth: 1440, margin: '0px auto'}}>
          <div style={{display: 'flex',alignItems: 'flex-end'}}>
            <Menu menuData={menuData} selectMenu={selectMenu} setSelectMenu={setSelectMenu} padding={'0 50px'}/>
            <div style={{width: '40%', paddingLeft: 30}}>
              <Input 
                size="large" 
                placeholder="Search" 
                prefix={<SearchOutlined />} 
                allowClear
                onPressEnter={(ev)=>{ 
                  getBlogListFn(ev.target.value)
                }}
              />
            </div>
          </div>
  
          {/* 推荐科技前沿 */}
          {selectMenu === 'All' && <div style={{ display: 'flex',margin: '50px auto',background:'#f2f2f0',borderRadius:'4px' }}>
            <div style={{width: '50%',display: 'flex',alignItems:'center',justifyContent: 'center'}}>
              <div style={{width: '70%',display: 'flex',flexDirection: 'column',alignItems:'flex-start',justifyContent: 'center'}}>
                <div>
                  <span style={{margin: '0 10px 0 0'}}>News</span>•
                  <span style={{margin: '0 10px'}}>Nutrition</span>•
                  <span style={{margin: '0 10px', color: 'rgba(0,0,0,0.54)'}}>Jul 19, 2024</span>
                </div>
                <div style={{fontSize: 'clamp(22px, calc(19.89px + 0.56vw), 28px)', margin: '20px 0'}}>
                  Meet Mitopure’s New Veggie-Cap Softgels
                </div>
                <div style={{fontSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)', color: 'rgba(0,0,0,0.54)'}}>
                  Discover Mitopure's® new veggie softgels: same proven benefits, now vegan-friendly with sustainable packaging and clean label certification.
                </div>
              </div>
            </div>
            <div style={{width: '50%'}}>
              <img style={{width: '100%',borderRadius:'4px'}} src={require('../../../image/goods-2640x1760.jpg')} alt="" />
            </div>
          </div>}
  
          {/* 科技前沿列表 + 科技前沿目录 */}
          <div style={{ display: 'flex', justifyContent: 'space-between', margin:'50px 0' }}>
            {/* 科技前沿列表 */}
            <div style={isDirectory? { width: '60%' }:{ width: '100%' }}>
              {selectMenu === 'All' && <div style={{fontSize: 'clamp(22px, calc(19.89px + 0.56vw), 28px)', marginBottom: 20}}>Recent posts</div>}
              <Row gutter={[30, 90]}>
                {articleList.map((e,i)=>{
                  return (
                    <Col key={i} span={isDirectory? 12:8}>
                      <CardDom type={e.type} content={e.content} btnConfig={e.btnConfig}/>
                    </Col>
                  )
                })}
              </Row>
              {/* <div style={{textAlign:'center'}}>
                <button className="btn" onClick={()=> navigate('/shopDetail')}>显示更多</button>
              </div> */}
            </div>
            {/* 科技前沿目录 */}
            {isDirectory && <div style={{ width: '30%', height: 'min-content', position:'sticky', top: 50 }}>
              <div style={{fontSize: 'clamp(22px, calc(19.89px + 0.56vw), 28px)', marginBottom: 20}}>推荐论文</div>
              
              <Divider style={{ borderColor: '#272724', margin:'15px 0' }} />
  
              {directoryList.map((e,i)=>{
                return (
                  <div className="directory-item" key={i} onClick={()=> {
                    if(e.btnConfig.linkType){
                      window.open(e.btnConfig.link, '_blank');
                    }else{
                      navigate(e.btnConfig.link)
                    }}}>
                    <div className="directory-item-top">
                      <div className="directory-item-num">{i+1}/</div>
                      <div className="directory-item-tag-box">
                        {/* {e.content.taglist.map((E,I)=>{
                          return <><span style={I === 0? {margin: '0 10px 0 0'}:{}}>{E}</span>•</>
                        })} */}
                        <span style={{ color: 'rgba(0,0,0,0.54)'}}>{e.content.time}</span>
                      </div>
                    </div>
                    <div className="directory-item-content">
                      <div>{e.content.title}</div>
                    </div>
                  </div>
                )
              })}
            </div> }
          </div>
        </div>
      </div>
    )
  }else{
    return (
      <div className="Blog-page" style={{textAlign: 'left'}}>
        <div style={{width: '100%', maxWidth: 1440, fontSize: 'clamp(40px, calc(31.55px + 2.25vw), 64px)', padding: '30px 25px 0'}}>
          Blog
        </div>
        
        <div style={{width: '100%', maxWidth: 1440, margin: '0px auto'}}>
          <div>
            <Menu menuData={menuData} selectMenu={selectMenu} setSelectMenu={setSelectMenu} padding={'0 25px'}/>
          </div>
          <div style={{width: '100%', padding: 25}}>
            <Input 
              size="large" 
              placeholder="Search" 
              prefix={<SearchOutlined />} 
              allowClear
              onPressEnter={(ev)=>{ 
                getBlogListFn(ev.target.value)
              }}
            />
          </div>

          {/* 推荐科技前沿 */}
          {selectMenu.label === 'All' && <div style={{width: '100%', padding: 25}}>
            <CardDom type={articleList[0].type} content={articleList[0].content} btnConfig={articleList[0].btnConfig}/>
          </div>}

          {/* 科技前沿列表 + 科技前沿目录 */}
          <div>
            {/* 科技前沿目录 */}
            {isDirectory && <div style={{ width: '100%', height: 'min-content', padding: 25 }}>
              <div style={{fontSize: 'clamp(22px, calc(19.89px + 0.56vw), 28px)', marginBottom: 20}}>推荐论文</div>
              
              <Divider style={{ borderColor: '#272724', margin:'15px 0' }} />

              {directoryList.map((e,i)=>{
                return (
                  <div className="directory-item" key={i}>
                    <div className="directory-item-top">
                      <div className="directory-item-num">{i+1}/</div>
                      <div className="directory-item-tag-box">
                        {/* {e.content.taglist.map(E=>{
                          return <><span style={I === 0? {margin: '0 10px 0 0'}:{}}>{E}</span>•</>
                        })} */}
                        <span style={{ color: 'rgba(0,0,0,0.54)'}}>{e.content.time}</span>
                      </div>
                    </div>
                    <div className="directory-item-content">
                      <div>{e.content.title}</div>
                    </div>
                  </div>
                )
              })}
            </div> }

            {/* 科技前沿列表 */}
            <div style={{ width: '100%', padding: '0 25px' }}>
              {selectMenu === '全部' && <div style={{fontSize: 'clamp(22px, calc(19.89px + 0.56vw), 28px)', marginBottom: 20}}>Recent posts</div>}
              <Row gutter={[30, 90]}>
                {articleList.map((e,i)=>{
                  return (
                    <Col key={i} span={24}>
                      <CardDom type={e.type} content={e.content} btnConfig={e.btnConfig}/>
                    </Col>
                  )
                })}
              </Row>
              {/* <div style={{textAlign:'center'}}>
                <button className="btn" onClick={()=> navigate('/')}>显示更多</button>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Blog